import { render, staticRenderFns } from "./inputInsertion.vue?vue&type=template&id=b90b5660&scoped=true"
import script from "./inputInsertion.vue?vue&type=script&lang=js"
export * from "./inputInsertion.vue?vue&type=script&lang=js"
import style0 from "./inputInsertion.vue?vue&type=style&index=0&id=b90b5660&prod&lang=css"
import style1 from "./inputInsertion.vue?vue&type=style&index=1&id=b90b5660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b5660",
  null
  
)

export default component.exports